export const setKolQuery = (result: any) => {
  return {
    type: "SET_KOL_QUERY",
    payload: result,
  }
}
